export default "__VITE_ASSET__DyvJ8wmP__"